import { ActionTypes } from "../constants";

const reduceMfaMethods = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_MFA_METHODS_SUCCESS:
            return action.data || [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceMfaMethods;
